// extracted by mini-css-extract-plugin
module.exports = {"container":"Table_container__1f0Xy","noResultCell":"Table_noResultCell__1gbmj","noResult":"Table_noResult__Xdso4"};